// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type { GenericApiResponseExamSessionResponse, HTTPValidationError, OpenExamSessionBody } from '../../models';

/**
 * Open a proctored exam session.
 * @summary Open Exam Session
 */
export const openExamSession = (
  slotId: string,
  openExamSessionBody: OpenExamSessionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseExamSessionResponse>> => {
  return axios.post(`/appointments/slots/${slotId}/exam-session/open`, openExamSessionBody, options);
};

export const getOpenExamSessionMutationOptions = <
  TData = Awaited<ReturnType<typeof openExamSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; data: OpenExamSessionBody }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['openExamSession'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof openExamSession>>,
    { slotId: string; data: OpenExamSessionBody }
  > = (props) => {
    const { slotId, data } = props ?? {};

    return openExamSession(slotId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OpenExamSessionBody },
    TContext
  >;
};

export type OpenExamSessionMutationResult = NonNullable<Awaited<ReturnType<typeof openExamSession>>>;
export type OpenExamSessionMutationBody = OpenExamSessionBody;
export type OpenExamSessionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Open Exam Session
 */
export const useOpenExamSession = <
  TData = Awaited<ReturnType<typeof openExamSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; data: OpenExamSessionBody }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string; data: OpenExamSessionBody }, TContext> => {
  const mutationOptions = getOpenExamSessionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Close a proctored exam session.
 * @summary Close Exam Session
 */
export const closeExamSession = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseExamSessionResponse>> => {
  return axios.post(`/appointments/slots/${slotId}/exam-session/close`, undefined, options);
};

export const getCloseExamSessionMutationOptions = <
  TData = Awaited<ReturnType<typeof closeExamSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['closeExamSession'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeExamSession>>, { slotId: string }> = (props) => {
    const { slotId } = props ?? {};

    return closeExamSession(slotId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { slotId: string }, TContext>;
};

export type CloseExamSessionMutationResult = NonNullable<Awaited<ReturnType<typeof closeExamSession>>>;

export type CloseExamSessionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Close Exam Session
 */
export const useCloseExamSession = <
  TData = Awaited<ReturnType<typeof closeExamSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string }, TContext> => {
  const mutationOptions = getCloseExamSessionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get current proctored exam session status.
 * @summary Get Exam Session Status
 */
export const getExamSessionStatus = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseExamSessionResponse>> => {
  return axios.get(`/appointments/slots/${slotId}/exam-session/status`, options);
};

export const getGetExamSessionStatusQueryKey = (slotId: string) => {
  return [`/appointments/slots/${slotId}/exam-session/status`] as const;
};

export const getGetExamSessionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getExamSessionStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExamSessionStatusQueryKey(slotId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExamSessionStatus>>> = ({ signal }) =>
    getExamSessionStatus(slotId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!slotId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExamSessionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExamSessionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getExamSessionStatus>>>;
export type GetExamSessionStatusQueryError = AxiosError<void | HTTPValidationError>;

export function useGetExamSessionStatus<
  TData = Awaited<ReturnType<typeof getExamSessionStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExamSessionStatus<
  TData = Awaited<ReturnType<typeof getExamSessionStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExamSessionStatus<
  TData = Awaited<ReturnType<typeof getExamSessionStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Exam Session Status
 */

export function useGetExamSessionStatus<
  TData = Awaited<ReturnType<typeof getExamSessionStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExamSessionStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetExamSessionStatusQueryOptions(slotId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
